import React, { useEffect, useState } from "react";
import { CrudModal } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { Typography, Button, Box, Checkbox } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { postQuestion, updateQuestion } from "../../services/question.service";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";

const AddQuestion = ({
  handleCloseDrawer,
  formType,
  selectedData,
  setOpenDrawer,
  GetQuestionData,
}) => {
  const dispatch = useDispatch();
  const disabled = formType === "view";
  const [questions, setQuestions] = useState({
    option: [
      { optionsName: "", score: "", isRemark: false },
      { optionsName: "", score: "", isRemark: false },
    ],
  });

  const validationSchema = yup.object().shape({
    questionName: yup.string().required("Question Name Required *"),
  });

  useEffect(() => {
    if (formType === "edit" || formType === "view") {
      setQuestions((prevQuestions) => ({
        ...prevQuestions,
        option: selectedData.options?.map((option) => ({
          optionsName: option.optionsName || "",
          score: option.score || "",
          isRemark: option.isRemark || false,
        })),
      }));
    }
  }, [formType, selectedData]);

  const handleNameChange = (index, value) => {
    const updatedQuestions = [...questions.option];
    updatedQuestions[index].optionsName = value;
    setQuestions({ ...questions, option: updatedQuestions });
  };

  const handleScoreChange = (index, value) => {
    const updatedQuestions = [...questions.option];
    updatedQuestions[index].score = value;
    setQuestions({ ...questions, option: updatedQuestions });
  };

  const handleRemarkChange = (index, checked) => {
    const updatedQuestions = [...questions.option];
    updatedQuestions[index].isRemark = checked;
    setQuestions({ ...questions, option: updatedQuestions });
  };

  const handleAddQuestion = () => {
    setQuestions((prevQuestions) => ({
      ...prevQuestions,
      option: [
        ...prevQuestions.option,
        { optionsName: "", score: "", isRemark: false },
      ],
    }));
  };

  const handleRemoveQuestion = (index) => {
    if (questions.option.length > 2) {
      setQuestions((prevQuestions) => ({
        ...prevQuestions,
        option: prevQuestions.option.filter((_, idx) => idx !== index),
      }));
    }
  };

  const onSubmit = async (values) => {
    values.options = questions.option;
    try {
      const apiMethod =
        formType === "edit"
          ? updateQuestion(selectedData._id, values)
          : postQuestion(values);
      const res = await apiMethod;
      setOpenDrawer(false);
      GetQuestionData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      dispatch(showToast({ message: "Select Valid Score", type: "error" }));
    }
  };

  return (
    <CrudModal
      title={
        formType === "add"
          ? "Add Question"
          : formType === "edit"
          ? "Edit Question"
          : "View Question"
      }
      open={true}
      handleClose={handleCloseDrawer}
      maxWidth="xl"
    >
      <Formik
        initialValues={{
          questionName: selectedData?.questionName,
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ touched, errors }) => (
          <div className="formContainer" style={{ height: "fit-content" }}>
            <Form>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Question Name
                  </Typography>
                  <Field
                    name="questionName"
                    className="InputField"
                    placeholder="Enter Question Name"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.questionName && errors.questionName
                      ? errors.questionName
                      : null}
                  </div>
                </Grid>
                {questions?.option?.map((question, index) => (
                  <React.Fragment key={index}>
                    <Grid size={{ xs: 12, sm: 5 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Name
                      </Typography>
                      <Field
                        name={`option[${index}].optionsName`}
                        className="InputField"
                        placeholder="Enter Option Name"
                        disabled={disabled}
                        value={question?.optionsName}
                        onChange={(e) =>
                          handleNameChange(index, e.target.value)
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 5 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Score
                      </Typography>
                      <Field
                        name={`option[${index}].score`}
                        className="InputField"
                        placeholder="Enter score"
                        disabled={disabled}
                        value={question?.score}
                        onChange={(e) =>
                          handleScoreChange(index, e.target.value)
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 2, md: 2, xl: 2 }}>
                      <Typography
                        className="InputTitle"
                        sx={{ marginBottom: "-2px" }}
                      >
                        &nbsp;
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          // justifyContent: "space-between",
                          gap: 2,
                          alignItems:"center"
                        }}
                      >
                        <Checkbox
                          checked={question.isRemark}
                          onChange={(e) =>
                            handleRemarkChange(index, e.target.checked)
                          }
                          disabled={disabled}
                        />
                        {/* {index > 1 && ( */}
                        {(formType === "edit" || formType === "add") && (
                          <DeleteOutlineOutlinedIcon
                            onClick={() => handleRemoveQuestion(index)}
                            sx={Styles[0].deleteIconStyle}
                          />
                        )}
                        {/* )} */}
                        {index === questions.option.length - 1 &&
                          (formType === "edit" || formType === "add") && (
                            <AddIcon
                              sx={Styles[0].editIconStyle}
                              onClick={() => handleAddQuestion(index)}
                            />
                          )}
                      </Box>
                    </Grid>
                  </React.Fragment>
                ))}
                <Grid size={{ xs: 12 }} mt={2}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "20px",
                    }}
                  >
                    <Button
                      className="cancelButton"
                      onClick={() => setOpenDrawer(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="addButton"
                      sx={{ display: formType === "view" ? "none" : "flex" }}
                    >
                      {formType === "edit" ? "Update" : "Save"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </div>
        )}
      </Formik>
    </CrudModal>
  );
};

export default AddQuestion;

const Styles = [
  {
    editIconStyle: {
      padding: "6px",
      border: "1px solid #D5D7E8",
      borderRadius: "5px",
      color: "#00675D",
      cursor: "pointer",
      height: "38px",
      width: "35px",
    },
    deleteIconStyle: {
      backgroundColor: "#FFE7E7",
      padding: "6px",
      borderRadius: "5px",
      color: "#DB3A3A",
      cursor: "pointer",
      border: "1px solid #D5D7E8",
      height: "38px",
      width: "35px",
    },
  },
];
